/**
 * Checks if the currently focused element is an input field.
 * Used to prevent keyboard shortcuts from triggering when user is typing.
 */
export function isInputElementFocused(): boolean {
  const activeElement = document.activeElement as HTMLElement;
  const tagName = activeElement?.tagName?.toLowerCase();

  return (
    tagName === 'input' ||
    tagName === 'textarea' ||
    tagName === 'select' ||
    activeElement?.contentEditable === 'true' ||
    activeElement?.isContentEditable
  );
}

/**
 * Tracks when Enter was last pressed in an input field.
 * Used to prevent shortcuts from triggering immediately after an input submission.
 */
let lastInputEnterTimestamp = 0;
const INPUT_ENTER_COOLDOWN_MS = 100;

export function markInputEnterPressed(): void {
  lastInputEnterTimestamp = Date.now();
}

export function wasRecentInputEnter(): boolean {
  return Date.now() - lastInputEnterTimestamp < INPUT_ENTER_COOLDOWN_MS;
}
